import { Stack, Typography } from '@mui/material';
import timeFormatter from 'frontend/utils/timeFormatter';
import dateFormatter from 'frontend/utils/dateFormatter';
import formatSecondsToHours, { getTimeDiffInSeconds } from 'frontend/utils/formatSecondsToHours';
import './flightCard.css';

const FlightScaleRow = (flight) => {
  const { arrival, arrivalDate, company, departure, departureDate, originDestinationReferences } =
    flight;

  const flightDuration = getTimeDiffInSeconds(departureDate, arrivalDate);

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '2rem', paddingLeft: '2rem' }}>
      <div className="vertical-dashed-line"></div>
      <Stack gap={3}>
        <Stack>
          <Stack flexDirection={'row'} alignItems={'end'} gap={1}>
            <Typography fontWeight={800} fontSize={'1.1rem'}>
              {timeFormatter(departureDate)}
            </Typography>
            <Typography fontSize={'0.9rem'} bottom={1} position={'relative'}>
              {dateFormatter(departureDate)}
            </Typography>
          </Stack>
          <Typography fontWeight={800}>{`${departure?.city}`}</Typography>
          <Typography fontSize={'0.85rem'} marginTop={'4px'}>
            {`${departure?.type === 'Airport' ? 'Aeropuerto' : ''} ${departure?.name}, ${
              departure?.country
            }`}
          </Typography>
        </Stack>

        <Stack flexDirection={'row'} gap={4}>
          <Stack>
            <Typography fontSize={'18x'} fontWeight={800}>
              {`Aerolínea: ${company}`}
            </Typography>
            <Typography fontSize={'14px'} fontWeight={400}>
              {`Duración: ${formatSecondsToHours(flightDuration)}`}
            </Typography>
          </Stack>
        </Stack>

        <Stack>
          <Stack flexDirection={'row'} alignItems={'end'} gap={1}>
            <Typography fontWeight={800} fontSize={'1.1rem'}>
              {timeFormatter(arrivalDate)}
            </Typography>
            <Typography fontSize={'0.9rem'} bottom={1} position={'relative'}>
              {dateFormatter(arrivalDate)}
            </Typography>
          </Stack>
          <Typography fontWeight={800}>
            {`${arrival?.city} (${originDestinationReferences})`}
          </Typography>
          <Typography fontSize={'0.85rem'} marginTop={'4px'}>
            {`${arrival?.type === 'Airport' ? 'Aeropuerto' : ''} ${arrival?.name}, ${
              arrival?.country
            }`}
          </Typography>
        </Stack>
      </Stack>
    </div>
  );
};

export default FlightScaleRow;
